class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.isInlineHeaderSearch = this.classList.contains('hn-nav__search-details');
    this.updateInlineSearchMetrics = this.updateInlineSearchMetrics.bind(this);

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');

    if (this.isInlineHeaderSearch) {
      window.addEventListener('resize', this.updateInlineSearchMetrics);
      requestAnimationFrame(this.updateInlineSearchMetrics);
    }
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.updateInlineSearchMetrics();
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    if (!this.isInlineHeaderSearch) document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    if (!this.isInlineHeaderSearch) document.body.classList.remove('overflow-hidden');
  }

  disconnectedCallback() {
    if (this.isInlineHeaderSearch) {
      window.removeEventListener('resize', this.updateInlineSearchMetrics);
    }
  }

  updateInlineSearchMetrics() {
    if (!this.isInlineHeaderSearch || !this.summaryToggle) return;
    const header = this.closest('.header.hn-nav');
    const menu = header && header.querySelector('.header__inline-menu');

    if (!header || !menu) return;

    const summaryRect = this.summaryToggle.getBoundingClientRect();
    const menuRect = menu.getBoundingClientRect();

    if (!summaryRect.width || !menuRect.width) return;

    const triggerWidth = Math.round(summaryRect.width);
    const expandedWidth = Math.round(summaryRect.right - menuRect.left);
    const resolvedExpandedWidth = Math.max(triggerWidth, expandedWidth);

    this.style.setProperty('--hn-inline-search-trigger-width', `${triggerWidth}px`);
    this.style.setProperty('--hn-inline-search-width', `${resolvedExpandedWidth}px`);
  }
}

customElements.define('details-modal', DetailsModal);
